import React from 'react';
import {
  Button,
  FormControl,
  FormHelperText,
  Grid,
  IconButton,
  Input,
  InputAdornment,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  TextField,
  Tooltip,
  Popover,
  List,
  ListItem,
  ListItemText
} from '@material-ui/core';

import Autocomplete, {
  createFilterOptions
} from '@material-ui/lab/Autocomplete';
import { controlType } from '../../../constants/common';
import _ from 'lodash';
import { Switch } from '../Switch';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import ClearIcon from '@material-ui/icons/Clear';
import moment from 'moment';
import {
  AddCircleOutlined,
  CloudUploadOutlined,
  Edit,
  AttachFileOutlinedIcon
} from '@material-ui/icons';
import PageHeader from '../PageHeader';
import Masonry from 'react-masonry-css';
import { isInputValid, removeDuplicates, setSectionFieldAttributeByKey, getSectionAttributeValueByKey, getSectionFieldByKey, removeNullValuesFromArray, getCurrentPayCycleStartDate, numberWithCommas } from '../../../utils/helper';
import { DateFormat, getSPSTokenData, Operators, setSPSToken } from '../../../constants/appConstants';
import VisibilityIcon from '@material-ui/icons/Visibility';
import InputMask from 'react-input-mask';
import ReactChipInput from '../ChipInput/ReactChipInput';
import DenseTable from '../../Dashboard/RenderTable';
import { ShowToast, toastType } from '../../../utils/toast-service';
import { CheckboxList } from '../CheckboxList';
import { CheckboxTable } from '../CheckboxTable';
import Chip from '@material-ui/core/Chip';

const FilterOptions = createFilterOptions();
const breakpointColumnsObj = {
  default: 2,
  1100: 2,
  700: 2,
  500: 1
};
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250
    }
  }
};

class FormGenerator extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      selectedFile: [],
      formElementFields: this.props.formFields,
      updatedFields: [],
      dropDownSourceData: [...(this.props.dropDownSource || [])],
      partialForm: this.props.partialForm || false,
      addNewformComponent: undefined,
      openaddform: false,
      formType: this.props.formType,
      validationMessages: this.props.validationMessages || [],
      ReloadForm: this.props.ReloadForm,
      isDialogOpen: false,
      Editable: this.props.Editable,
      history: this.props.historyData,
      parentKey: this.props.parentKey || ''
    };
  }

  componentDidMount() { }

  static getDerivedStateFromProps(newpros, state) {
    if (
      JSON.stringify(newpros.formFields) !==
      JSON.stringify(state.formElementFields) ||
      newpros.ReloadForm !== state.ReloadForm ||
      newpros.Editable !== state.Editable
    ) {
      return {
        formElementFields:
          state.inErrorState === true
            ? state.formElementFields
            : newpros.formFields,
        ReloadForm: newpros.ReloadForm,
        inErrorState: newpros.inErrorState,
        dropDownSourceData: newpros.dropDownSource,
        validationMessages:
          (newpros.validationMessages || []).length > 0
            ? newpros.validationMessages
            : state.validationMessages,
        Editable: newpros.Editable
      };
    }
    return null;
  }

  closeDialog = () => {
    this.setState({ isDialogOpen: false });
  };

  getChangedData = (obj) => {
    return {};
  };

  renderField = (obj) => {
    const isEditable =
      this.props.Editable === false ? true : obj.isEditable !== true;
    const { dropDownSourceData } = this.state;
    // const changedData = this.getChangedData(obj);
    const { isInErrorState, errorMessage } = obj;
    let componentToBeRendered = <></>;
    // if (obj.dependentField)
    const source =
      (dropDownSourceData || []).find(
        (x) =>
          _.camelCase(x.key).toLowerCase().trim() ===
          _.camelCase(obj.key || '')
            .toLowerCase()
            .trim()
      ) || {};

    if (obj.attributeValue !== undefined && obj.attributeValue !== null) {
      // defaultValues = (obj.attributeValue || '').split('|');
      obj.attributeValue = isNaN(obj.attributeValue) ? obj.attributeValue?.replace('&amp;', '&') : obj.attributeValue;
    }
    if (obj.renderAsWhen !== undefined) {
      const renderAsWhenkey = obj.renderAsWhen.key;
      const renderAsWhenValue = obj.renderAsWhen.value || '';
      if (
        (
          (
            this.state.formElementFields.find(
              (x) => _.camelCase(x.dbColumn) === _.camelCase(renderAsWhenkey)
            ) || {}
          ).attributeValue || ''
        ).toString() === renderAsWhenValue.toString()
      ) {
        obj.type = obj.renderAsWhen.type;
      }
    }

    if (obj.type === controlType.Chip) {
      obj.isEditable === true
        ? componentToBeRendered = (
          <>
            <ReactChipInput
              disabled={!obj.isEditable}
              addEditPageField={true}
              // label={obj.displayName}
              className={'custom-chipinput'}
              value={obj.attributeValue?.split('|')}
              label={<><span>{obj.displayName + ' (Stream Email Only)'}</span> {!isEditable && obj.isRequired ? <span className="error-text">*</span> : ''} </>}
              onChange={(emailArray) => {
                // let value = obj.attributeValue?.split('|');
                console.log(emailArray.join('|'));
                this.onChangeValues(
                  emailArray.join('|'),
                  obj,
                  undefined,
                  false,
                  source
                );
              }}

            />
          </>
        )
        :
        // this.renderChips(
        //   isEditable,
        //   obj
        // );
        componentToBeRendered = this.renderDisabledChips(obj);
    } else if (obj.type === controlType.DropDown) {
      let sourceData = source.source || [];
      let defaultValues = [];
      if (obj.multiple) {
        if (obj.attributeValue !== undefined && obj.attributeValue !== null) {
          defaultValues = (obj.attributeValue || '').split('|');
          if (defaultValues.length > 1) {
            defaultValues.sort();
          }
        }
        obj.displayName = obj.displayName.replace('(s)', '') + '(s)';
      } else {
        obj.displayName = obj.displayName.replace('(s)', '');
      }
      if (source.filterSourceOn && source.applyFilter !== false) {
        source.filterSourceOn.forEach((ele) => {
          const idValue = [];
          if (typeof ele.key === 'string') {
            // idValue.push(
            //   (
            //     this.state.formElementFields.find(
            //       (x) => _.camelCase(x.dbColumn) === _.camelCase(ele.key)
            //     ) || {}
            //   ).attributeValue
            // );
            const temp = (
              this.state.formElementFields.find(
                (x) => _.camelCase(x.dbColumn) === _.camelCase(ele.key)
              ) || {}
            );
            if (temp.multiple) {
              ((temp.attributeValue || '').split('|') || []).forEach(xv => {
                idValue.push(xv);
              });
            } else {
              idValue.push(temp.attributeValue);
            }
          } else {
            ele.key.forEach((elementkey) => {
              const val = (
                this.state.formElementFields.find(
                  (x) => _.camelCase(x.dbColumn) === _.camelCase(elementkey)
                ) || {}
              );
              if (val.multiple || ele.multiple === true) {
                val.attributeValue?.toString().split('|').forEach(xv => {
                  idValue.push(xv);
                });
              } else {
                idValue.push(val.attributeValue);
              }
            });
          }

          if ((idValue || source.filterMode === 'strict') && ele.ignore !== true) {
            if (ele.allowNullorEmpty) {
              if (ele.isFieldValueMandatory) {
                const tempIdValue = removeNullValuesFromArray(idValue);
                sourceData = sourceData.filter((x) =>
                  (tempIdValue.length > 0 && (x[ele.filterBy] === null || x[ele.filterBy] === undefined || x[ele.filterBy] === '')) ||
                  (idValue || []).find(
                    (val) =>
                    (((x[ele.filterBy] || '').toString() === (val || '').toString() || x[source.idField] < 0) ||
                      ((x[ele.filterBy] || '').toString().split('|') || []).find(y =>
                        y === (val || '').toString() || x[source.idField] < 0))
                  )
                );
              } else {
                sourceData = sourceData.filter((x) =>
                  x[ele.filterBy] === null || x[ele.filterBy] === undefined || x[ele.filterBy] === '' ||
                  (idValue || []).find(
                    (val) =>
                    (((x[ele.filterBy] || '').toString().toLowerCase() === (val || '').toString().toLowerCase() || x[source.idField] < 0) ||
                      ((x[ele.filterBy] || '').toString().toLowerCase().split('|') || []).find(y =>
                        y === (val || '').toString().toLowerCase() || x[source.idField] < 0))
                  )
                );
              }
            } else if (ele.allowAllIfNotSelected) {
              const tempIdValue = removeNullValuesFromArray(idValue);
              sourceData = (tempIdValue || []).length === 0
                ? sourceData
                : sourceData.filter((x) =>
                  (idValue || []).find(
                    (val) =>
                    (((x[ele.filterBy] || '').toString() === (val || '').toString() || x[source.idField] < 0) ||
                      ((x[ele.filterBy] || '').toString().split('|') || []).find(y =>
                        y === (val || '').toString() || x[source.idField] < 0))
                  )
                );
            } else {
              sourceData = sourceData.filter((x) =>
                (idValue || []).find(
                  (val) =>
                  (((x[ele.filterBy] || '').toString() === (val || '').toString() || x[source.idField] < 0) ||
                    ((x[ele.filterBy] || '').toString().split('|') || []).find(y =>
                      y === (val || '').toString() || x[source.idField] < 0))
                )
              );
            }
          }
        });
      }
      if (source.filterMode === 'AppendExisting') {
        const defaultsourceData = source.source.filter((x) =>
          defaultValues.find((v) => v === x[source.option])
        );
        (defaultsourceData || []).forEach(
          pr => {
            if (sourceData.find(spr => spr[source.option] === pr[source.option]) === undefined) {
              sourceData.push(pr);
            }
          }
        );
      }

      defaultValues = defaultValues.filter((dfx) =>
        sourceData.find((sdy) => sdy[source.option]?.toLowerCase().trim() === dfx?.toLowerCase().trim())
      );
      defaultValues = removeDuplicates(defaultValues);
      // if (obj.attributeValue !== defaultValues)
      // {
      //         this.onChangeValues(defaultValues, obj.dbColumn, sourceIdField, obj.multiple, source);

      // }
      if (
        obj.isEditable === true &&
        source.AddNewOption === true &&
        source.AddOptionType !== 'Button'
      ) {
        const addOption = {};
        addOption[source.option] = source.AddNewOptiontitle;
        sourceData.push(addOption);
      }
      if (sourceData.length === 1 &&
        obj.isRequired &&
        defaultValues.length === 0 &&
        source.AddNewOption !== true &&
        (obj.sectionId !== 37 && obj.sectionId !== 49 && obj.onChange !== undefined)) {
        defaultValues.push(sourceData[0][source.option]);
        if (obj.multiple !== true) {
          obj.attributeValue = sourceData[0][source.option];
        }
      }
      if (sourceData.length > 0 && source.ignoreSort !== true) {
        sourceData = _.orderBy(sourceData, [source.option], (source.sortOrder === undefined ? ['asc'] : [source.sortOrder]));
      }
      componentToBeRendered = (
        <>
          {source.AddNewOption === true && source.AddOptionType === 'Button'
            ? (
              <div className="row no-padding">
                <div className="col-xs-11 no-padding">
                  {this.renderAutofillWithAdd(
                    isEditable,
                    obj,
                    sourceData,
                    source,
                    defaultValues,
                    isInErrorState,
                    errorMessage
                  )}
                </div>
                {obj.isEditable === true && (
                  <div className="col-xs-1">
                    <IconButton
                      aria-label={'addnewrow' + source.Key}
                      className="action-button"
                      size="small"
                      onClick={() => {
                        source.onAddClick &&
                          source.onAddClick({ ...source }, '', false);
                        // this.setState({ openaddform: true, addformtitle: source.AddNewOptiontitle, addNewformComponent: source.AddOptionComponent });
                      }}
                    >
                      {obj.isAdded
                        ? (
                          <Edit
                            fontSize="small"
                            size="small"
                            title={source.AddNewOptiontitle}
                          />
                        )
                        : (
                          <AddCircleOutlined
                            fontSize="small"
                            size="small"
                            title={source.AddNewOptiontitle}
                          />
                        )}
                    </IconButton>
                  </div>
                )}
              </div>
            )
            : (
              this.renderAutofill(
                isEditable,
                obj,
                sourceData,
                source,
                defaultValues,
                isInErrorState,
                errorMessage
              )
            )}
        </>
      );
      // }
    } else if (obj.type === controlType.Autofill) {
      if (isEditable) {
        componentToBeRendered = (
          <TextField
            error={isInErrorState}
            helperText={errorMessage}
            disabled={true}
            id={
              this.props.parentKey +
              `text-field-${obj.sectionDetailId + obj.dbColumn + obj.sectionId
              }`
            }
            key={
              this.props.parentKey +
              `text-field-${obj.sectionDetailId + obj.dbColumn + obj.sectionId
              }`
            }
            label={<><span>{obj.displayName}</span> {!isEditable && obj.isRequired ? <span className="error-text">*</span> : ''} </>}
            className={obj.isHighlight ? 'special-field' : ''}

            fullWidth
            value={obj.attributeValue || ''}
          />
        );
      } else {
        let defaultValues = [];
        if (obj.multiple) {
          if (obj.attributeValue !== undefined && obj.attributeValue !== null) {
            defaultValues = (obj.attributeValue || '').split('|');
          }
          obj.displayName = obj.displayName?.replace('(s)', '') + '(s)';
        } else {
          obj.displayName = obj.displayName?.replace('(s)', '');

          defaultValues.push(obj.attributeValue);
        }

        if (source && source.source && source.source.length > 0 && source.source.find(xd => xd[source.option] === '') === undefined) {
          source.source.unshift({ [source.option]: '' });
        }

        componentToBeRendered = (
          <Autocomplete
            freeSolo
            autoSelect={true}
            autoHighlight={true}
            error={isInErrorState}
            helperText={errorMessage}
            disabled={isEditable}
            disableClearable={isEditable}
            multiple={obj.multiple || false}
            value={obj.multiple === true ? defaultValues : obj.attributeValue || ''}
            key={
              this.state.parentKey +
              'Autocomplete_dropDown_filter' +
              obj.dbColumn +
              obj.sectionId
            }
            id={'AutoCompletedropDown_filter' + obj.dbColumn + obj.sectionId}

            filterOptions={(options, params) => {
              const filtered = FilterOptions(options, params);

              if (params.inputValue !== '') {
                const a = {};
                a[source.option] = `Add "${params.inputValue}"`;
                a.inputValue = params.inputValue;
                filtered.push(a);
              }

              return filtered;
            }}
            onChange={(event, newValue) => {
              const sourceIdField = {};
              let value = '';
              if (typeof newValue === 'string') {
                sourceIdField.key = source.idField;
                sourceIdField.value = -1;
                value = newValue;
              } else if (newValue && newValue.inputValue) {
                // Create a new value from the user input
                sourceIdField.key = source.idField;
                sourceIdField.value = -1;
                value = newValue.inputValue;
              } else {
                value = newValue[source.option];
                sourceIdField.key = source.idField;
                sourceIdField.value = newValue[source.idField];
              }

              if (source.idField) {
                const selectedValue =
                  source.source.find(
                    (x) => x[_.camelCase(source.option)] === value
                  ) || {};
                if (selectedValue) {
                  sourceIdField.key = source.idField;
                  sourceIdField.value =
                    selectedValue[
                    _.camelCase(source.optionIdField || source.idField)
                    ];
                }
              } else {
                sourceIdField.key = source.idField;
                sourceIdField.value = -1;
              }
              this.onChangeValues(
                value,
                obj,
                sourceIdField,
                obj.multiple,
                source
              );
            }
            }
            options={(source.source || [])}
            getOptionLabel={(option) => {
              // e.g value selected with enter, right from the input
              if (typeof option === 'string') {
                return option;
              }
              if (option.inputValue) {
                return option.inputValue;
              }
              return option[source.option];
            }}
            // selectOnFocus
            clearOnBlur
            handleHomeEndKeys
            renderOption={(option) => option[source.option]}
            // autoHighlight
            renderInput={(params) => (
              <TextField
                error={isInErrorState}
                errorMessage={errorMessage}
                {...params}
                label={<><span>{obj.displayName}</span> {!isEditable && obj.isRequired ? <span className="error-text">*</span> : ''} </>}
                className={obj.isHighlight ? 'special-field' : ''}
                helperText={errorMessage}
                margin="normal"
              />
            )}
          />
        );
      }
    } else if (obj.type === controlType.DatePicker) {
      let selectedDate = moment(obj.attributeValue || '').format('MM/DD/YYYY');
      if (moment(selectedDate).isValid() !== true) {
        selectedDate = null;
      }
      if (isEditable) {
        componentToBeRendered = (
          <TextField
            error={isInErrorState}
            helperText={errorMessage}
            disabled={true}
            id={
              this.props.parentKey +
              `text-field-${obj.sectionDetailId + obj.dbColumn + obj.sectionId
              }`
            }
            key={
              this.props.parentKey +
              `text-field-${obj.sectionDetailId + obj.dbColumn + obj.sectionId
              }`
            }
            label={<><span>{obj.displayName}</span> {!isEditable && obj.isRequired ? <span className="error-text">*</span> : ''} </>}
            className={obj.isHighlight ? 'special-field' : ''}

            InputLabelProps={{ shrink: isEditable }}
            fullWidth
            value={selectedDate || ''}
          />
        );
      } else {
        componentToBeRendered = (<>
          <MuiPickersUtilsProvider
            utils={DateFnsUtils}
            key={
              this.state.parentKey +
              '_datePicker_filter' +
              obj.dbColumn +
              obj.sectionId +
              obj.sectionDetailId
            }
          >
            <Grid container>
              <KeyboardDatePicker
                size="small"
                disabled={isEditable}
                error={isInErrorState}
                helperText={errorMessage}
                clearable={true}
                format="MM/dd/yyyy"
                margin="normal"
                minDate={obj.minDate ? obj.minDate : undefined}
                fullWidth
                id="date-picker-dialog"
                label={<><span>{obj.displayName}</span> {!isEditable && obj.isRequired ? <span className="error-text">*</span> : ''} </>}
                className={obj.isHighlight ? 'special-field' : ''}
                shouldDisableDate={obj.shouldDisableDate}
                // value={selectedDate || null}
                value={moment(selectedDate).format('MM/DD/YYYY') !== 'Invalid date' &&
                  moment(selectedDate).format('MM/DD/YYYY') !== '01/01/1900'
                  ? selectedDate
                  : null}
                onChange={(date) => {
                  if (
                    date !== '' &&
                    moment(date).format('MM/DD/YYYY') !== 'Invalid date' &&
                    moment(date).format('MM/DD/YYYY') !== '01/01/1900'
                  ) {
                    this.onChangeValues(moment(date).format('MM/DD/YYYY'), obj);
                  } else {
                    this.onChangeValues(null, obj);
                  }
                  // this.onChangeValues(date, obj);
                }}
                KeyboardButtonProps={{
                  'aria-label': 'change date'
                }}
                InputProps={{
                  endAdornment: obj.attributeValue && (
                    <IconButton
                      disabled={isEditable}
                      size="small"
                      onClick={() => {
                        this.onChangeValues('', obj);
                      }}
                    >
                      <ClearIcon size="small" />
                    </IconButton>
                  )
                }}
                InputAdornmentProps={{
                  position: 'start'
                }}
              />
            </Grid>
          </MuiPickersUtilsProvider>
          {obj.helperText && <FormHelperText>
            {obj.helperText}
          </FormHelperText>}
        </>
        );
      }
    } else if (obj.type === controlType.Switch) {
      if (isEditable) {
        componentToBeRendered = (
          <TextField
            error={isInErrorState}
            helperText={errorMessage}
            disabled={true}
            id={
              this.props.parentKey +
              `text-field-${obj.sectionDetailId + obj.dbColumn + obj.sectionId
              }`
            }
            key={
              this.props.parentKey +
              `text-field-${obj.sectionDetailId + obj.dbColumn + obj.sectionId
              }`
            }
            label={<><span>{obj.displayName}</span> {!isEditable && obj.isRequired ? <span className="error-text">*</span> : ''} </>}
            className={obj.isHighlight ? 'special-field' : ''}

            InputLabelProps={{ shrink: isEditable }}
            fullWidth
            value={(obj.attributeValue || '').toString() === '1' ? 'Yes' : 'No'}
          />
        );
      } else {
        componentToBeRendered = (
          <Switch
            isChecked={obj.attributeValue === '1'}
            disabled={isEditable}
            onChangeValues={(checked, key) => {
              let value = '0';
              if (checked === true) {
                value = '1';
              }
              this.onChangeValues(value, obj);
            }}
            id={
              this.props.parentKey +
              `switch-${obj.sectionDetailId + obj.dbColumn + obj.sectionId}`
            }
            Key={
              this.props.parentKey +
              `switch-${obj.sectionDetailId + obj.dbColumn + obj.sectionId}`
            }
            obj={obj}
            labelText={<><span>{obj.displayName}</span> {!isEditable && obj.isRequired ? <span className="error-text">*</span> : ''} </>}
            fieldKey={obj.dbColumn}
            fullWidth
          />
        );
      }
    } else if (obj.type === controlType.CheckboxList) {
      componentToBeRendered = (
        <>
          <CheckboxList
            isEditable={isEditable}
            value={obj.attributeValue}
            sourceData={source}
            onChange={(event) => {
              this.onChangeValues(
                event,
                obj,
                undefined,
                false,
                source
              );
            }} />
          {obj.isInErrorState && obj.errorMessage &&
            <span className="customError-text">{obj.overrideErrorMessage ? obj.overrideErrorMessage : obj.errorMessage}</span>}
        </>
      );
    } else if (
      obj.type === controlType.File ||
      obj.type === controlType.FileInput
    ) {
      componentToBeRendered = (
        <>
          <div className="row">
            <div className="col-sm-8 no-padding">
              <TextField
                error={isInErrorState}
                helperText={errorMessage}
                disabled={true}
                id={
                  this.props.parentKey +
                  `text-field-${obj.sectionDetailId + obj.dbColumn + obj.sectionId
                  }`
                }
                key={
                  this.props.parentKey +
                  `text-field-${obj.sectionDetailId + obj.dbColumn + obj.sectionId
                  }`
                }
                label={<><span>{obj.displayName}</span> {!isEditable && obj.isRequired ? <span className="error-text">*</span> : ''} </>}
                className={obj.isHighlight ? 'special-field' : ''}

                fullWidth
                value={(obj.attributeValue || '').split('|').length > 1 ? (obj.attributeValue || '').split('|')[1] : (obj.attributeValue || '')}
                InputLabelProps={{ shrink: true }}
              />
            </div>
            {(obj.attributeValue !== null && (obj.attributeValue || '').split('|').length > 1) &&
              (
                <div className="col-sm-1">
                  <>
                    <Tooltip title="Document's Count">
                      {/* <InputAdornment position="start"><span style={{ fontSize: '13px', color: '#B1B3B3' }}>$</span></InputAdornment> */}
                      <Chip
                        size={'small'}
                        key={'chip' + obj.dbColumn}
                        label={'+' + ((obj.attributeValue || '').split('|').length - 1) || ''.toString()}
                        style={{ margin: 1 }}
                        disabled
                      />
                    </Tooltip>
                  </>
                </div>
              )
            }
            <div className="col-sm-1">
              <Tooltip title={isEditable === false ? 'View/Upload Document(s)' : 'View Document(s)'}>
                <IconButton className="action-button" size="small">
                  <VisibilityIcon
                    size="small"
                    onClick={(e) => {
                      if (obj.showListOnPopover && obj.attributeValue !== null && obj.attributeValue !== '') {
                        this.handleClick(e, obj.dbColumn);
                      } else {
                        this.props.viewPDF(
                          obj,
                          obj.displayName
                        );
                      }
                    }}
                  />
                </IconButton>
              </Tooltip>
              {obj.showListOnPopover &&
                (<Popover
                  key={'PopOverKey' +
                    obj.dbColumn +
                    '_Wrapper'}
                  id={
                    'PopOver' +
                    obj.dbColumn +
                    '_Wrapper'
                  }
                  open={obj.dbColumn === 'DocumentName' ? this.state.openMenu : (obj.dbColumn === 'ChangeOfOwnershipDocumentName' ? this.state.openMenuCIO : this.state.openMenuTermination)}
                  anchorEl={obj.dbColumn === 'DocumentName' ? this.state.anchorEl : (obj.dbColumn === 'ChangeOfOwnershipDocumentName' ? this.state.anchorElCIO : this.state.anchorElTermination)}
                  onClose={this.handleClose}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right'
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right'
                  }}
                >
                  <List
                    key={'popoverList' + obj.dbColumn}
                    component="nav"
                    aria-label="mailbox folders"
                    className="widgetMenu"
                  >
                    {obj.attributeValue !== null &&
                      ((obj.attributeValue || '').split('|') || []).map(
                        (key, i) => (
                          <ListItem
                            size="small"
                            key={'popoverListItem' + obj.dbColumn + i + key}
                            // selected={key?.operator?.name === selectedAdvanceFilter || (key?.operator?.name === 'In' && selectedAdvanceFilter === '')}
                            divider
                            button
                            onClick={() => {
                              this.props.viewPDF(
                                obj,
                                obj.displayName,
                                key
                              );
                            }}
                          >
                            <ListItemText primary={key} />
                          </ListItem>
                        )
                      )}
                  </List>
                </Popover>
                )}
            </div>
            {/* {isEditable === false && (
              <div className="col-sm-1">
                <Tooltip title="Upload Document">
                  <IconButton
                    className="action-button"
                    variant="contained"
                    size="small"
                    component="label"
                  >
                    <CloudUploadOutlined size="small"></CloudUploadOutlined>
                    <input
                      type="file"
                      hidden
                      multiple={obj.multiple || false}
                      onChange={(event) => {
                        this.onFileChange(event, obj);
                      }}
                      accept="application/pdf"
                    />
                  </IconButton>
                </Tooltip>
              </div>
            )} */}
            {/* <div className="col-sm-1">
              {obj.attributeValue !== null
                ? (
                  <>
                    <Tooltip title="View Document">
                      <IconButton className="action-button" size="small">
                        <VisibilityIcon
                          size="small"
                          onClick={(e) => {
                            this.props.viewPDF(
                              obj,
                              // obj.attributeValue
                              obj.displayName
                            );
                          }}
                        />
                      </IconButton>
                    </Tooltip>
                  </>
                )
                : null}
            </div> */}
          </div>
        </>
      );
    } else if (obj.type === controlType.PhoneNumber) {
      let inpProps = {};
      if (
        _.camelCase(obj.dataFormat) === _.camelCase('PhoneNumber') ||
        _.camelCase(obj.dataFormat) === _.camelCase('PhoneNumber')
      ) {
        inpProps = {
          startAdornment: (
            <InputAdornment position="start"><span style={{ fontSize: '13px', color: '#B1B3B3' }}>(+1)</span></InputAdornment>
          )
        };
      }
      componentToBeRendered = (
        <InputMask
          mask="999-999-9999"
          maskChar=" "
          disabled={isEditable}
          id={
            this.props.parentKey +
            `text-field-${obj.sectionDetailId + obj.dbColumn + obj.sectionId}`
          }
          key={
            this.props.parentKey +
            `text-field-${obj.sectionDetailId + obj.dbColumn + obj.sectionId}`
          }
          label={<><span>{obj.displayName}</span> {!isEditable && obj.isRequired ? <span className="error-text">*</span> : ''} </>}
          className={obj.isHighlight ? 'special-field' : ''}

          fullWidth
          value={obj.attributeValue || ''}
          onChange={(event) => {
            this.onChangeValues(
              event.target.value,
              obj,
              undefined,
              false,
              source
            );
          }}
        >
          {() => (
            <TextField
              InputProps={inpProps}
              disabled={isEditable}
              error={isInErrorState}
              helperText={errorMessage}
              margin="normal"
              size="small"
              color="primary"
              label={<><span>{obj.displayName}</span> {!isEditable && obj.isRequired ? <span className="error-text">*</span> : ''} </>}
              className={obj.isHighlight ? 'editable special-field' : 'editable'}

            />
          )}
        </InputMask>
      );
    } else if (obj.type === controlType.JSONTable) {
      const data = JSON.parse(obj.attributeValue);
      componentToBeRendered = (
        <DenseTable
          data={data.data}
          columns={data.config.map((c) => { return { key: c.DBColumn, name: c.DisplayName }; })}
          tableConfig={data.config}
        ></DenseTable>
      );
    } else if (obj.type === controlType.Table) {
      componentToBeRendered = (
        <>
          <CheckboxTable
            value={obj.attributeValue}
            sourceData={source}
            isDisabled={isEditable}
            onChange={(event) => {
              this.onChangeValues(
                event,
                obj,
                undefined,
                false,
                source
              );
            }}

          ></CheckboxTable>
          {obj.isInErrorState && obj.errorMessage &&
            <span className="customError-text">{obj.errorMessage}</span>}
        </>
      );
    } else {
      let inpProps = {};
      if (
        _.camelCase(obj.dataFormat) === _.camelCase('MoneyDecimal') ||
        _.camelCase(obj.dataFormat) === _.camelCase('MoneyNumber')
      ) {
        inpProps = {
          startAdornment: <InputAdornment position="start"><span style={{ fontSize: '13px', color: '#B1B3B3' }}>$</span></InputAdornment>
        };
      }
      if (_.camelCase(obj.dbColumn) === _.camelCase('AreaSF')) {
        if (this.props.isEditable !== true && obj.attributeValue !== null && obj.attributeValue !== '' && isNaN(obj.attributeValue) !== true) {
          // if (obj.isEditable !== true) {
          if (isEditable === true) {
            obj.attributeValue = numberWithCommas(parseInt(obj.attributeValue?.replace(',', '')));
          }
        }
        inpProps = {
          startAdornment: <InputAdornment position="end"><span style={{ fontSize: '13px', color: '#B1B3B3' }}>sf</span></InputAdornment>
        };
      }
      if (_.camelCase(obj.dbColumn) === _.camelCase('TotalSF') || _.camelCase(obj.dbColumn) === _.camelCase('LegalEntitySF')) {
        if (obj.isEditable === false && obj.attributeValue !== null && obj.attributeValue !== '' && isNaN(obj.attributeValue) !== true) {
          obj.attributeValue = numberWithCommas(parseInt(obj.attributeValue));
        }
        inpProps = {
          startAdornment: <InputAdornment position="end"><span style={{ fontSize: '13px', color: '#B1B3B3' }}>sf</span></InputAdornment>
        };
      }
      if (
        _.camelCase(obj.dataFormat) === _.camelCase('DecimalPercent') ||
        _.camelCase(obj.dataFormat) === _.camelCase('Percent')
      ) {
        inpProps = {
          endAdornment: <InputAdornment position="end"><span style={{ fontSize: '13px', color: '#B1B3B3' }}>%</span></InputAdornment>
        };
      }
      componentToBeRendered = (
        <TextField
          error={isInErrorState}
          helperText={errorMessage}
          disabled={isEditable}
          id={
            this.props.parentKey +
            `text-field-${obj.sectionDetailId + obj.dbColumn + obj.sectionId}`
          }
          key={
            this.props.parentKey +
            `text-field-${obj.sectionDetailId + obj.dbColumn + obj.sectionId}`
          }
          InputProps={inpProps}
          label={<><span>{obj.displayName}</span> {!isEditable && obj.isRequired ? <span className="error-text">*</span> : ''} </>}
          className={obj.isHighlight ? 'special-field' : ''}

          InputLabelProps={{ shrink: obj.shrink ? obj.shrink : undefined }}
          fullWidth
          value={obj.attributeValue || ''}
          onChange={(event) => {
            this.onChangeValues(
              event.target.value,
              obj,
              undefined,
              false,
              source
            );
          }}
        />
      );
    }
    return (
      <div className="row">
        <div
          className={
            'col-xs-' +
            (this.props.innerFieldColumn || 12) +
            ' no-padding field-container ' + obj.className
          }
        >
          {componentToBeRendered}
        </div>
      </div>
    );
  };

  handleClick = (event, dbColumn) => {
    if (dbColumn === 'DocumentName') {
      this.setState({ anchorEl: event.currentTarget, openMenu: true });
    } else if (dbColumn === 'ChangeOfOwnershipDocumentName') {
      this.setState({ anchorElCIO: event.currentTarget, openMenuCIO: true });
    } else {
      this.setState({ anchorElTermination: event.currentTarget, openMenuTermination: true });
    }
  };

  handleClose = () => {
    this.setState({ anchorEl: null, anchorElCIO: null, anchorElTermination: null, openMenu: false, openMenuCIO: false, openMenuTermination: false });
  }

  onFileChange = (event, obj) => {
    if (event.target && !event.target.files.length) return;
    obj.attributeValue = '';
    Array.from(event.target.files)?.forEach((file) => {
      if (file.type !== 'application/pdf') {
        ShowToast('Please select PDF file', toastType.WARNING, 5000, 500);
        event.target.value = null;
        return false;
      }
      if (obj.uploadToSp === true) {
        this.props.getUploadedFile(file, obj.category);
        this.onChangeValues(file.name, obj);
        this.onChangeValues(
          obj.category,
          this.state.formElementFields.find(
            (y) => _.camelCase(y.dbColumn) === _.camelCase(obj.contentKey)
          ) || {}
        );
      } else {
        this.getBase64(file, (result) => {
          // console.log(result);
          this.onChangeValues(
            result,
            this.state.formElementFields.find(
              (y) => _.camelCase(y.dbColumn) === _.camelCase(obj.contentKey)
            ) || {}
          );
        });
        this.onChangeValues(file.name, obj);
      }
    });
  };

  getBase64 = (file, cb) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      cb(reader.result);
    };
    reader.onerror = function (error) {
      console.log(error);
    };
  };

  getFileData = (contentKey) => {
    const BlobString = this.state.formElementFields.find(
      (x) => _.camelCase(x.dbColumn) === _.camelCase(contentKey)
    );
    if (BlobString) {
      // const blob = this.base64toBlob(BlobString.attributeValue);
      // const url = URL.createObjectURL(blob);
      return BlobString.attributeValue;
    }
    return undefined;
  };

  base64toBlob = (data) => {
    // Cut the prefix `data:application/pdf;base64` from the raw base 64
    const base64WithoutPrefix = data.substr(
      'data:application/pdf;base64,'.length
    );

    const bytes = atob(base64WithoutPrefix);
    let length = bytes.length;
    const out = new Uint8Array(length);

    while (length--) {
      out[length] = bytes.charCodeAt(length);
    }

    return new Blob([out], { type: 'application/pdf' });
  };

  onChangeValues = (
    val,
    obj,
    sourceIdField,
    isMultiple,
    source = undefined
  ) => {
    const formFieldsObj = [...this.state.formElementFields];
    if (obj.isRequired === false) {
      obj.isInErrorState = false;
      obj.errorMessage = '';
    }

    // if (obj.dbColumn === 'IsNonUsState') {
    //   let key = obj.dependentField.key;
    //   let newType = obj.dependentField.type.find(x => x.whenValue == val)?.type;

    //   setSectionFieldAttributeByKey(formFieldsObj, key, 'type', newType);
    //   setSectionFieldAttributeByKey(formFieldsObj, key, 'attributeValue', '');
    // }
    if (obj.dbColumn === 'AssignmentEndDate') {
      const extendedDate = getSectionAttributeValueByKey(formFieldsObj, obj.dependentField.key);
      if (extendedDate === null || extendedDate === '') {
        obj.isInErrorState = false;
        obj.errorMessage = '';
      } else {
        const aDate = new Date(moment(val)).getTime();
        const bDate = new Date(moment(extendedDate)).getTime();
        const result = Operators.GreaterThanEqualsTo(bDate, aDate);

        if (result.result) {
          setSectionFieldAttributeByKey(formFieldsObj, obj.dbColumn, 'isInErrorState', false);
          setSectionFieldAttributeByKey(formFieldsObj, obj.dbColumn, 'errorMessage', '');
          setSectionFieldAttributeByKey(formFieldsObj, obj.dependentField.key, 'isInErrorState', false);
          setSectionFieldAttributeByKey(formFieldsObj, obj.dependentField.key, 'errorMessage', '');
        } else {
          setSectionFieldAttributeByKey(formFieldsObj, obj.dbColumn, 'isInErrorState', true);
          setSectionFieldAttributeByKey(formFieldsObj, obj.dbColumn, 'errorMessage', 'Service(s) End Date must be less than Grace Period (Property Accounting) date');
        }
      }
      const assignmentStartDate = getSectionAttributeValueByKey(formFieldsObj, 'assignmentStartDate');
      if (assignmentStartDate !== null || assignmentStartDate === '') {
        const aDate = new Date(moment(val)).getTime();
        const bDate = new Date(moment(assignmentStartDate)).getTime();
        const result = Operators.GreaterThan(aDate, bDate);

        if (result.result) {
          setSectionFieldAttributeByKey(formFieldsObj, obj.dbColumn, 'isInErrorState', false);
          setSectionFieldAttributeByKey(formFieldsObj, obj.dbColumn, 'errorMessage', '');
          setSectionFieldAttributeByKey(formFieldsObj, obj.dependentField.key, 'isInErrorState', false);
          setSectionFieldAttributeByKey(formFieldsObj, obj.dependentField.key, 'errorMessage', '');
        } else {
          setSectionFieldAttributeByKey(formFieldsObj, obj.dbColumn, 'isInErrorState', true);
          setSectionFieldAttributeByKey(formFieldsObj, obj.dbColumn, 'errorMessage', 'Service(s) End Date must be greater than Service Start Date');
        }
      }
    }
    if (obj.dbColumn === 'ExtendedDate') {
      if (this.props?.isFromGraceForm === true) {
        const assignmentEndDate = getSectionAttributeValueByKey(formFieldsObj, 'assignmentEndDate');

        if (val === null || val === '') {
          setSectionFieldAttributeByKey(formFieldsObj, obj.dbColumn, 'isInErrorState', true);
          setSectionFieldAttributeByKey(formFieldsObj, obj.dbColumn, 'errorMessage',
            'Grace Period (Property Accounting) field is required and should be in MM/DD/YYYY format.');
        } else {
          const aDate = new Date(moment(val)).getTime();
          const bDate = new Date(moment(assignmentEndDate)).getTime();
          const result = Operators.GreaterThan(aDate, bDate);
          if (result.result === true) {
            const payCycleStartDate = moment(getCurrentPayCycleStartDate()).format('MM/DD/YYYY');
            const cDate = new Date(moment(payCycleStartDate)).getTime();
            const result1 = Operators.GreaterThan(cDate, aDate);
            if (result1.result) {
              setSectionFieldAttributeByKey(formFieldsObj, obj.dbColumn, 'isInErrorState', true);
              setSectionFieldAttributeByKey(formFieldsObj, obj.dbColumn, 'errorMessage',
                'Grace Period(Property Accounting) should be greater than or equal to Current Pay Cycle Start Date');
            } else {
              setSectionFieldAttributeByKey(formFieldsObj, obj.dbColumn, 'isInErrorState', false);
              setSectionFieldAttributeByKey(formFieldsObj, obj.dbColumn, 'errorMessage',
                '');
            }
          } else {
            setSectionFieldAttributeByKey(formFieldsObj, obj.dbColumn, 'isInErrorState', true);
            setSectionFieldAttributeByKey(formFieldsObj, obj.dbColumn, 'errorMessage', 'Grace Period(Property Accounting) should be greater than Service(s) End Date');
          }
        }
      } else {
        const aDate = new Date(moment(val)).getTime();
        // getSectionAttributeValueByKey(formFieldsObj, obj.dependentField.key);
        const assignmentEndDate = getSectionAttributeValueByKey(formFieldsObj, obj?.dependentField?.key);
        const bDate = new Date(moment(assignmentEndDate)).getTime();

        const result = Operators.GreaterThanEqualsTo(aDate, bDate);
        if (result.result) {
          setSectionFieldAttributeByKey(formFieldsObj, obj.dbColumn, 'isInErrorState', false);
          setSectionFieldAttributeByKey(formFieldsObj, obj.dbColumn, 'errorMessage', '');
          setSectionFieldAttributeByKey(formFieldsObj, obj.dependentField.key, 'isInErrorState', false);
          setSectionFieldAttributeByKey(formFieldsObj, obj.dependentField.key, 'errorMessage', '');
        } else {
          setSectionFieldAttributeByKey(formFieldsObj, obj.dbColumn, 'isInErrorState', true);
          setSectionFieldAttributeByKey(formFieldsObj, obj.dbColumn, 'errorMessage', 'Grace Period(Property Accounting) should be greater than Service(s) End Date');
        }
      }
    }
    if (obj.dependentField && obj.dependentField.displayName && obj.dependentField.displayName.length > 0) {
      const dependentFieldValue = obj.dependentField.displayName.find(x => x.whenValue === sourceIdField?.value);
      if (dependentFieldValue) {
        setSectionFieldAttributeByKey(formFieldsObj, obj.dependentField.key, 'displayName', dependentFieldValue.label);
        setSectionFieldAttributeByKey(formFieldsObj, obj.dependentField.key, 'isVisible', dependentFieldValue.isVisible);
      }
    }
    if (obj.key === 'sourceAccountingSystem' && (obj.changePropertyCodeValidations || false) === true) {
      const existingSourceAccoutingTypeId = getSectionAttributeValueByKey(formFieldsObj, 'SourceAccountingSystemId');
      setSectionFieldAttributeByKey(formFieldsObj, 'yardiCode', 'dataFormat', existingSourceAccoutingTypeId?.toString() === '2' ? 'Text' : 'NumericText');
      const objYardiCode = formFieldsObj.find((field) => _.camelCase(field.dbColumn) === 'yardiCode') || {};
      isInputValid(objYardiCode?.attributeValue, objYardiCode, formFieldsObj);
    }

    if (source && source.localChanges === false && source.onChange) {
      source.onChange(val, sourceIdField, isMultiple);
      return;
    }
    if (obj.type === 'FileInput' || obj.type === 'File') {
      (
        formFieldsObj.find(
          (field) => _.camelCase(field.dbColumn) === _.camelCase(obj.dbColumn)
        ) || {}
      ).attributeValue = val; // obj.attributeValue + '|' + val;
    } else {
      (
        formFieldsObj.find(
          (field) => _.camelCase(field.dbColumn) === _.camelCase(obj.dbColumn)
        ) || {}
      ).attributeValue =
        isMultiple === true
          ? val.join('|')
          : typeof val === 'object' && val !== undefined
            ? (val || {})[_.camelCase(obj.dbColumn)]
            : val;
    }
    obj = isInputValid(
      isMultiple === true
        ? val.join('|')
        : typeof val === 'object' && val !== undefined
          ? (val || {})[_.camelCase(obj.dbColumn)]
          : val,
      obj,
      this.state.formElementFields
    );
    (
      formFieldsObj.find(
        (field) => _.camelCase(field.dbColumn) === _.camelCase(obj.dbColumn)
      ) || {}
    ).isInErrorState = obj.isInErrorState;
    (
      formFieldsObj.find(
        (field) => _.camelCase(field.dbColumn) === _.camelCase(obj.dbColumn)
      ) || {}
    ).errorMessage = obj.errorMessage;

    if (sourceIdField !== undefined && val !== undefined) {
      (
        formFieldsObj.find(
          (obj) => _.camelCase(obj.dbColumn) === _.camelCase(sourceIdField.key)
        ) || {}
      ).attributeValue =
        isMultiple === true
          ? sourceIdField.value.join('|')
          : typeof val === 'object' && val !== undefined
            ? (val || {})[_.camelCase(sourceIdField.key)]
            : sourceIdField.value;
    }
    if (obj.dbColumn === 'AssignmentEndDate') {
      const extendedDate = getSectionFieldByKey(formFieldsObj, 'ExtendedDate');
      if (extendedDate.isVisible === true) {
        if (extendedDate.attributeValue === null || extendedDate.attributeValue === '') {
          obj.isInErrorState = false;
          obj.errorMessage = '';
          // const assignmentStartDate = getSectionAttributeValueByKey(formFieldsObj, 'assignmentStartDate');
          // if (assignmentStartDate !== null || assignmentStartDate === '') {
          //   const aDate = new Date(moment(val)).getTime();
          //   const bDate = new Date(moment(assignmentStartDate)).getTime();
          //   const result = Operators.GreaterThan(aDate, bDate);

          //   if (result.result) {
          //     setSectionFieldAttributeByKey(formFieldsObj, obj.dbColumn, 'isInErrorState', false);
          //     setSectionFieldAttributeByKey(formFieldsObj, obj.dbColumn, 'errorMessage', '');
          //     // setSectionFieldAttributeByKey(formFieldsObj, obj.dependentField.key, 'isInErrorState', false);
          //     // setSectionFieldAttributeByKey(formFieldsObj, obj.dependentField.key, 'errorMessage', '');
          //   } else {
          //     setSectionFieldAttributeByKey(formFieldsObj, obj.dbColumn, 'isInErrorState', true);
          //     setSectionFieldAttributeByKey(formFieldsObj, obj.dbColumn, 'errorMessage', 'Service(s) End Date must be greater than Service Start Date');
          //   }
          // }
        }
      }
    }
    if (obj.dbColumn === 'ExtendedDate') {
      if (this.props?.isFromGraceForm === true) {
        const assignmentEndDate = getSectionAttributeValueByKey(formFieldsObj, 'assignmentEndDate');
        if (val === null || val === '') {
          setSectionFieldAttributeByKey(formFieldsObj, obj.dbColumn, 'isInErrorState', true);
          setSectionFieldAttributeByKey(formFieldsObj, obj.dbColumn, 'errorMessage',
            'Grace Period (Property Accounting) field is required and should be in MM/DD/YYYY format.');
        } else {
          const aDate = new Date(moment(val)).getTime();
          const bDate = new Date(moment(assignmentEndDate)).getTime();
          const result = Operators.GreaterThan(aDate, bDate);
          if (result.result === true) {
            const payCycleStartDate = moment(getCurrentPayCycleStartDate()).format('MM/DD/YYYY');
            const cDate = new Date(moment(payCycleStartDate)).getTime();
            const result1 = Operators.GreaterThan(cDate, aDate);
            if (result1.result) {
              setSectionFieldAttributeByKey(formFieldsObj, obj.dbColumn, 'isInErrorState', true);
              setSectionFieldAttributeByKey(formFieldsObj, obj.dbColumn, 'errorMessage',
                'Grace Period(Property Accounting) should be greater than or equal to Current Pay Cycle Start Date');
            } else {
              setSectionFieldAttributeByKey(formFieldsObj, obj.dbColumn, 'isInErrorState', false);
              setSectionFieldAttributeByKey(formFieldsObj, obj.dbColumn, 'errorMessage',
                '');
            }
          } else {
            setSectionFieldAttributeByKey(formFieldsObj, obj.dbColumn, 'isInErrorState', true);
            setSectionFieldAttributeByKey(formFieldsObj, obj.dbColumn, 'errorMessage', 'Grace Period(Property Accounting) should be greater than Service(s) End Date');
          }
        }
      }
    }
    if (
      source === undefined ||
      source.validateBeforeChange === undefined ||
      source.validateBeforeChange(val, obj.dbColumn, sourceIdField, isMultiple)
    ) {
      this.setState(
        {
          formElementFields: formFieldsObj
        },
        () => {
          source &&
            source.onChange &&
            source.onChange(val, sourceIdField, isMultiple, formFieldsObj);
          obj.onChange && obj.onChange(val, sourceIdField, isMultiple, formFieldsObj);
          if (this.state.partialForm === true) {
            this.props.saveChanges(formFieldsObj);
          }
        }
      );
    }
  };

  renderChips = (isEditable, obj) => {
    const values = obj.attributeValue.split('|');
    values.map(x => {
      return (
        <Chip key={x} label={x} disabled />
      );
    });
  }

  renderDisabledChips = (obj) => {
    return (
      <FormControl
        disabled
        key={
          'FormControl_multiple-master-label' + obj.dbColumn
        }
        fullWidth
      >
        <InputLabel

          id={'mutiple-master-label' + obj.dbColumn}
        >
          {obj.displayName + ' (Stream Email Only)'}
        </InputLabel>
        <Select
          className={'icon-disappear'}
          disabled
          labelId={'mutiple-master-label' + obj.dbColumn}
          id={'mutiple-master-select' + obj.dbColumn}
          multiple
          defaultChecked={obj?.attributeValue?.split('|') || []}
          defaultValue={obj?.attributeValue?.split('|') || []}

          input={
            <Input
              key={
                'mutiple-master-chipInput' + obj.dbColumn
              }
              id={
                'mutiple-master-chipInput' + obj.dbColumn
              }
            />
          }
          renderValue={(selected) => (
            <div
              style={{
                display: 'flex',
                flexWrap: 'wrap'
              }}
            >
              {selected.map((value, i) => (
                <Chip
                  key={'chip' + obj.dbColumn + i}
                  label={value}
                  style={{ margin: 2 }}
                  disabled
                />
              ))}
            </div>
          )}
          MenuProps={MenuProps}
        >
          {(obj?.attributeValue?.split('|') || []).map((data, ic) => (
            <MenuItem
              key={'masteroption' + obj.dbColumn + ic}
              value={data}
            >
              {data}
            </MenuItem>
          ))}
        </Select>

      </FormControl>
    );
  }

  renderAutofill = (
    isEditable,
    obj,
    sourceData,
    source,
    defaultValues,
    isInErrorState,
    errorMessage
  ) => {
    if (sourceData?.length > 0 && source?.ignoreSort !== true) {
      sourceData = _.orderBy(sourceData, [source.option], (source.sortOrder === undefined ? ['asc'] : [source.sortOrder]));
    }
    if (sourceData && sourceData.length > 0 && sourceData.find(xd => xd[source.option] === '') === undefined) {
      sourceData.unshift({ [source.option]: '', key: "All" });
    }
    sourceData = removeDuplicates(sourceData);
    const fixedOptions = defaultValues || [];
    if ((defaultValues || []).length === 1 && defaultValues[0].trim() === "") {
      defaultValues = [];
    }
    return (
      <Autocomplete
        size="small"
        // autoSelect={true}
        autoHighlight={true}
        selectOnFocus
        blurOnSelect
        error={isInErrorState}
        helperText={errorMessage}
        disabled={isEditable}
        disableClearable={isEditable}
        multiple={obj.multiple || false}
        options={(sourceData || []).map((option) => option[source.option])}
        value={obj.multiple === true ? defaultValues : obj.attributeValue || ''}
        key={
          this.state.parentKey +
          '_dropDown_filter' +
          obj.dbColumn +
          obj.sectionId
        }
        id={'dropDown_filter' + obj.dbColumn + obj.sectionId}
        onChange={(event, value) => {
          if (value === source.AddNewOptiontitle) {
            source.onAddClick && source.onAddClick({ ...source });

            // this.setState({ openaddform: true, addformtitle: value, addNewformComponent: source.AddOptionComponent });
          } else {
            let sourceIdField = {};

            if (source.idField && obj.multiple === true) {
              sourceIdField.key = source.idField;
              const SelectedRecordMultiple = [];
              value.forEach((sourceValue) => {
                const filteredDataSource = sourceData.find(
                  (x) => x[_.camelCase(source.option)] === sourceValue
                );
                filteredDataSource &&
                  SelectedRecordMultiple.push(
                    filteredDataSource[
                    _.camelCase(source.optionIdField || source.idField)
                    ]
                  );
              });

              sourceIdField.key = source.idField;
              sourceIdField.value = SelectedRecordMultiple;
            } else if (source.idField) {
              const selectedValue =
                sourceData.find(
                  (x) => x[_.camelCase(source.option)] === value
                ) || {};
              if (selectedValue) {
                sourceIdField.key = source.idField;
                sourceIdField.value =
                  selectedValue[
                  _.camelCase(source.optionIdField || source.idField)
                  ];
              }
            } else {
              sourceIdField = undefined;
            }
            this.onChangeValues(
              value,
              obj,
              sourceIdField,
              obj.multiple,
              source
            );
            // source.onChange && source.onChange(value, sourceIdField, obj.multiple);
          }
        }}
        // renderTags={(tagValue, getTagProps) =>
        //   tagValue.map((option, index) => (
        //     <Chip
        //       KEY={option + index}
        //       label={option}
        //       {...getTagProps({ index })}
        //       disabled={fixedOptions.indexOf(option) !== -1}
        //     />
        //   ))
        // }
        // autoHighlight
        renderInput={(params) => (
          <TextField
            {...params}
            error={isInErrorState}
            errorMessage={errorMessage}
            label={<><span>{obj.displayName}</span> {!isEditable && obj.isRequired ? <span className="error-text">*</span> : ''} </>}
            className={obj.isHighlight ? 'special-field' : ''}
            margin="normal"
            // helperText={obj.isInErrorState ? obj.displayName + ' field is required' : ''}
            helperText={obj.isInErrorState ? obj.errorMessage : ''}
          />
        )}
      />
    );
  };

  renderAutofillWithAdd = (
    isEditable,
    obj,
    sourceData,
    source,
    defaultValues,
    isInErrorState,
    errorMessage
  ) => {
    if ((sourceData.length || 0) <= 0) {
      if (obj.multiple) {
        defaultValues = [];
      } else {
        obj.attributeValue = undefined;
      }
    } else {
      sourceData = _.orderBy(sourceData, [source.option], ['asc']);
    }
    if (sourceData && sourceData.length > 0 && sourceData.find(xd => xd[source.option] === '') === undefined) {
      sourceData.unshift({ [source.option]: '' });
    }

    const fixedOptions = defaultValues || [];
    if (obj.multiple === true && obj.dbColumn === 'PropertyName') {
      sourceData = sourceData.filter(x => x.propertyId > 0 || defaultValues.find(y => y === x[source.option]));
    }
    return (
      <Autocomplete
        size="small"
        autoComplete='new-password'
        autocomplete='new-password'
        autoHighlight={true}
        disabled={isEditable}
        disableClearable={isEditable}
        error={isInErrorState}
        errorMessage={errorMessage}
        multiple={obj.multiple || false}
        value={obj.multiple === true ? defaultValues : obj.attributeValue || ''}
        key={
          this.state.parentKey +
          '_dropDown_filter' +
          obj.dbColumn +
          obj.sectionId +
          obj.sectionDetailId
        }
        id={
          'dropDown_filter' + (obj.dbColumn === 'PropertyName' ? 'prn' : obj.dbColumn) + obj.sectionId + obj.sectionDetailId
        }
        onChange={(event, value) => {
          if (typeof value === 'string') {
            source.onAddClick && source.onAddClick({ ...source }, value);
          } else if (value && value.inputValue) {
            source.onAddClick &&
              source.onAddClick({ ...source }, value.inputValue);
          } else if (obj.multiple === true && value && value.length > 0 && value[value.length - 1].inputValue) {
            source.onAddClick &&
              source.onAddClick({ ...source }, value[value.length - 1].inputValue);
          } else {
            let sourceIdField = {};

            if (source.idField && obj.multiple === true) {
              sourceIdField.key = source.idField;
              const SelectedRecordMultiple = [];
              const SelectedMultiple = [];

              value.forEach((sourceValue) => {
                const filteredDataSource = sourceData.find(
                  (x) =>
                    x[_.camelCase(source.option)] ===
                    (typeof sourceValue === 'object'
                      ? sourceValue[source.option]
                      : sourceValue)
                );
                if (filteredDataSource) {
                  SelectedRecordMultiple.push(
                    filteredDataSource[
                    _.camelCase(source.optionIdField || source.idField)
                    ]
                  );
                  SelectedMultiple.push(
                    filteredDataSource[_.camelCase(source.option)]
                  );
                }
              });

              sourceIdField.key = source.idField;
              sourceIdField.value = SelectedRecordMultiple;
              this.onChangeValues(
                SelectedMultiple,
                obj,
                sourceIdField,
                obj.multiple,
                source
              );
              // source.onChange && source.onChange(SelectedMultiple, sourceIdField, obj.multiple);
            } else {
              if (source.idField) {
                const selectedValue =
                  sourceData.find(
                    (x) =>
                      x[_.camelCase(source.option)] ===
                      (value || {})[source.option]
                  ) || {};
                if (selectedValue) {
                  sourceIdField.key = source.idField;
                  sourceIdField.value =
                    selectedValue[
                    _.camelCase(source.optionIdField || source.idField)
                    ];
                }
              } else {
                sourceIdField = undefined;
              }
              this.onChangeValues(
                (value || {})[source.option],
                obj,
                sourceIdField,
                obj.multiple,
                source
              );
              // source.onChange && source.onChange((value || {})[source.option], sourceIdField, obj.multiple);
            }
          }
        }}
        filterOptions={(options, params) => {
          const filtered = FilterOptions(options, params);

          if (params.inputValue !== '') {
            const a = {};
            a[source.option] = `Add "${params.inputValue}"`;
            a.inputValue = params.inputValue;
            filtered.push(a);
          }

          return filtered;
        }}
        options={sourceData}
        getOptionLabel={(option) => {
          // e.g value selected with enter, right from the input
          if (typeof option === 'string') {
            return option;
          }
          if (option.inputValue) {
            return option.inputValue;
          }
          return option[source.option];
        }}
        getOptionSelected={(option, selectedVal) => {
          if (typeof selectedVal === 'string') {
            return option[source.option] === selectedVal;
          }
          return option[source.option] === (selectedVal[source.option] || selectedVal);
        }}
        // selectOnFocus
        clearOnBlur
        handleHomeEndKeys
        renderOption={(option) => {
          const isAlreadySelected = obj.multiple === true && Array.isArray(defaultValues) && defaultValues.includes(option[source.option]);
          return (
            <span style={isAlreadySelected ? { fontWeight: 600, color: '#1976d2' } : {}}>
              {option[source.option]}
            </span>
          );
        }}
        // renderTags={(tagValue, getTagProps) =>
        //   tagValue.map((option, index) => (
        //     <Chip
        //       KEY={option + index}
        //       label={option}
        //       {...getTagProps({ index })}
        //       disabled={fixedOptions.indexOf(option) !== -1}
        //     />
        //   ))
        // }
        // autoHighlight
        renderInput={(params) => (
          <TextField
            error={isInErrorState}
            errorMessage={errorMessage}
            {...params}
            autocomplete="new-password"
            autoComplete='new-password'
            label={<><span>{obj.displayName}</span> {!isEditable && obj.isRequired ? <span className="error-text">*</span> : ''} </>}
            className={obj.isHighlight ? 'special-field' : ''}
            margin="normal"
            helperText={obj.isInErrorState ? obj.errorMessage : ''}
          />
        )}
      />
    );
  };

  render() {
    const { formElementFields } = this.state;
    let formElement = <></>;
    if (formElementFields && this.state.formType === undefined) {
      formElement = this.renderNormalForm(formElementFields);
    } else {
      formElement = this.rendersectionForm(formElementFields);
    }
    return (
      <form autoComplete='off'>
        <div className="row form-section" style={{ paddingTop: '10px', paddingBottom: '10px' }}>{formElement}</div>
        {this.props.showSubmitButton !== false && this.state.Editable !== false && this.state.partialForm === false &&
          this.props.saveChanges !== undefined && (
            <div className="row bottom-xs">
              <div
                className={'col-xs-12 col-lg-12 field-control'}
                style={{ marginTop: '10px', marginBottom: '10px' }}
              >
                <Button
                  size="small"
                  variant="contained"
                  onClick={() => {
                    this.validateRequiredFields() &&
                      this.props.saveChanges(
                        _.cloneDeep(this.state.formElementFields)
                      );
                  }}
                >
                  {this.props.submitText ? this.props.submitText : 'Submit'}
                </Button>
              </div>
            </div>
          )}
      </form>
    );
  }

  validateRequiredFields = () => {
    const { formElementFields } = this.state;
    let IsValid = true;
    formElementFields.forEach((ele) => {
      isInputValid(ele.attributeValue, ele, formElementFields);
      if (ele.isInErrorState === true) {
        IsValid = false;
      }
    });

    if (IsValid) {
      return true;
    } else {
      this.setState({
        formElementFields: formElementFields,
        inErrorState: true
      });
      return false;
    }
  };

  renderNormalForm(formFields) {
    return formFields
      .filter((x) => x.isVisible === true)
      .map((obj, index) => (
        <>
          {this.props.separatorConfig &&
            this.props.separatorConfig.find(
              (x) =>
                _.camelCase(x.separatorBeforeKey) === _.camelCase(obj.dbColumn)
            ) && (
              <>
                <div className="col-sm-12 start-sm innerHeader">
                  <PageHeader
                    key={
                      this.state.parentKey +
                      '_separator-' +
                      _.camelCase(obj.dbColumn)
                    }
                    title={
                      (this.props.separatorConfig || []).find(
                        (x) =>
                          _.camelCase(x.separatorBeforeKey) ===
                          _.camelCase(obj.dbColumn)
                      ).label
                    }
                  ></PageHeader>

                  <hr className="hr-custom" />
                </div>
              </>
            )}
          <div
            className={
              'col-xs-12 col-lg-' +
              (obj.columnWidth
                ? obj.columnWidth
                : this.props.gridColumn > 2 ? this.props.gridColumn : 4) +
              ' field-control'
            }
          >
            {this.renderField(obj)}
          </div>
          {index % 2 === 0 && this.props.gridColumn <= 2 && (
            <div
              key={
                this.state.parentKey +
                `formEmptyField_${obj.sectionDetailId + obj.dbColumn + obj.sectionId
                }`
              }
              className={'col-xs-12 col-sm-offset-1'}
            ></div>
          )}
          {this.props.separatorConfig &&
            this.props.separatorConfig.find(
              (x) =>
                _.camelCase(x.separatorAfterKey) === _.camelCase(obj.dbColumn)
            ) && (
              <>
                <div className="col-sm-12 start-sm innerHeader">
                  <PageHeader
                    key={this.state.parentKey + '_separator-' + obj.dbColumn}
                    title={
                      this.props.separatorConfig.find(
                        (x) =>
                          _.camelCase(x.separatorAfterKey) ===
                          _.camelCase(obj.dbColumn)
                      ).label
                    }
                  ></PageHeader>

                  <hr className="hr-custom" />
                </div>
              </>
            )}
          {this.props.separatorConfig &&
            this.props.separatorConfig.find(
              (x) =>
                _.camelCase(x.separatorAfterKey) === _.camelCase(obj.dbColumn)
            ) && (
              <>
                <div className="col-sm-12 start-sm innerHeader">
                  <PageHeader
                    key={this.state.parentKey + '_separator-' + obj.dbColumn}
                    title={
                      this.props.separatorConfig.find(
                        (x) =>
                          _.camelCase(x.separatorAfterKey) ===
                          _.camelCase(obj.dbColumn)
                      ).label
                    }
                  ></PageHeader>

                  <hr className="hr-custom" />
                </div>
              </>
            )}
          {this.props.separatorConfig &&
            this.props.separatorConfig.find(
              (x) =>
                _.camelCase(x.separatorAfterKey) === _.camelCase(obj.dbColumn)
            ) && (
              <>
                <div className="col-sm-12 start-sm innerHeader">
                  <PageHeader
                    key={
                      this.state.parentKey +
                      '_separator-' +
                      _.camelCase(obj.dbColumn)
                    }
                    title={
                      this.props.separatorConfig.find(
                        (x) =>
                          _.camelCase(x.separatorAfterKey) ===
                          _.camelCase(obj.dbColumn)
                      ).label
                    }
                  ></PageHeader>

                  <hr className="hr-custom" />
                </div>
              </>
            )}
        </>
      ));
  }

  rendersectionForm(fields) {
    let formData = [];
    const finalFormData = [];

    const sectionDataDetails = [];
    let sectionData;
    const sectionRowConfig = [...(this.props.sectionRowConfig || [])];

    fields?.filter((x) => x.isVisible === true)?.forEach((obj) => {
      if (
        this.props.separatorConfig &&
        this.props.separatorConfig.find(
          (x) =>
            _.camelCase(x.separatorBeforeKey) === _.camelCase(obj.dbColumn)
        )
      ) {
        ({ formData, sectionData } = this.processSectionData(
          formData,
          finalFormData,
          sectionData,
          sectionDataDetails
        ));
        sectionData = {};
        const separatorConfig =
          (this.props.separatorConfig || []).find(
            (x) =>
              _.camelCase(x.separatorBeforeKey) === _.camelCase(obj.dbColumn)
          ) || {};
        sectionData.order = separatorConfig.order || 0;
        sectionData.row = separatorConfig.row || 0;
        sectionData.label = separatorConfig.label;
        sectionData.sectionColumn = separatorConfig.sectionColumn || 4;
        sectionData.fields = [];
        sectionData.infoLabel = separatorConfig.infoLabel;
      }

      if (sectionData !== undefined) {
        sectionData.fields.push(
          <div
            className={
              'col-xs-12 col-lg-' +
              (obj.columnWidth
                ? obj.columnWidth
                : sectionData.sectionColumn > 2
                  ? sectionData.sectionColumn
                  : 6) +
              ' field-control'
            }
          >
            {this.renderField(obj)}
          </div>
        );
      } else {
        formData.push(
          <div
            className={
              'col-xs-12 col-lg-' +
              (obj.columnWidth
                ? obj.columnWidth
                : this.props.gridColumn > 2 ? this.props.gridColumn : 4) +
              ' field-control'
            }
          >
            {this.renderField(obj)}
          </div>
        );
      }

      if (
        this.props.separatorConfig &&
        this.props.separatorConfig.find(
          (x) =>
            _.camelCase(x.separatorAfterKey) === _.camelCase(obj.dbColumn)
        )
      ) {
        ({ formData, sectionData } = this.processSectionData(
          formData,
          finalFormData,
          sectionData,
          sectionDataDetails
        ));
        sectionData = {};
        const separatorConfig =
          (this.props.separatorConfig || []).find(
            (x) =>
              _.camelCase(x.separatorAfterKey) === _.camelCase(obj.dbColumn)
          ) || {};
        sectionData.order = separatorConfig.order || 0;
        sectionData.row = separatorConfig.row || 0;
        sectionData.label = separatorConfig.label;
        sectionData.sectionColumn = separatorConfig.sectionColumn || 4;
        sectionData.fields = [];
      }
    });

    ({ formData, sectionData } = this.processSectionData(
      formData,
      finalFormData,
      sectionData,
      sectionDataDetails
    ));

    if (
      this.props.otherChildsection &&
      this.props.otherChildsection.length > 0
    ) {
      this.props.otherChildsection.forEach((ele, i) => {
        sectionDataDetails.push({
          row: ele.row,
          element: (
            <div
              className="col-xs-12 start-sm bottom-sm item"
              key={
                this.state.parentKey +
                '_sectionDataDetails-row-' +
                _.camelCase(ele.label) +
                i
              }
            >
              <Paper
                key={
                  this.state.parentKey +
                  '_sectionDataDetails-row-paper' +
                  _.camelCase(ele.label) +
                  i
                }
              >
                <div
                  className="row bottom-xs"
                  key={
                    this.state.parentKey +
                    '_sectionDataDetails-row-paper-container' +
                    _.camelCase(ele.label) +
                    i
                  }
                >
                  <div
                    className="col-xs-12 innerHeader"
                    key={
                      this.state.parentKey +
                      '_sectionDataDetails-row-paper-container-inner' +
                      _.camelCase(ele.label) +
                      i
                    }
                  >
                    <PageHeader
                      key={this.state.parentKey + '_separator-' + ele.label + i}
                      title={ele.label}
                    ></PageHeader>
                    <hr className="hr-custom" />
                  </div>
                  {ele.element}
                </div>
              </Paper>
            </div>
          )
        });
      });
    }
    formData = [];
    _.orderBy(sectionDataDetails, ['order', 'row'], ['asc']).forEach((ele) => {
      if (sectionRowConfig) {
        if (
          ((sectionRowConfig || []).find((x) => x.row === ele.row) || {})
            .element === undefined
        ) {
          (
            (sectionRowConfig || []).find((x) => x.row === ele.row) || {}
          ).element = [];
        }
        (
          ((sectionRowConfig || []).find((x) => x.row === ele.row) || {})
            .element || []
        ).push(ele.element);
      } else {
        formData.push(ele.element);
      }
    });

    if (formData && formData.length > 0) {
      finalFormData.push(
        <div className="col-xs-12">
          <div>
            <Masonry
              breakpointCols={breakpointColumnsObj}
              className="my-masonry-grid"
              columnClassName="my-masonry-grid_column"
            >
              {formData}
            </Masonry>
          </div>
        </div>
      );
    } else {
      if (sectionRowConfig) {
        finalFormData.push(
          <div className="col-xs-12">
            <div className="row">
              {sectionRowConfig.map((x, i) => (
                <div
                  key={
                    this.state.parentKey +
                    '_sectionRowConfig-finalFormData-row' +
                    i
                  }
                  className={'col-xs-12 col-sm-' + x.column}
                >
                  {(x.element || []).map((e, index) => (
                    <div
                      className={'row ' + (index > 0 ? 'margin-top' : '')}
                      key={this.state.parentKey + i + 'inner-child_' + index}
                    >
                      {e}
                    </div>
                  ))}
                </div>
              ))}
            </div>
          </div>
        );
      }
    }
    return finalFormData;
  }

  processSectionData(formData, finalFormData, sectionData, sectionDataDetails) {
    if (formData && formData.length > 0) {
      finalFormData.push(
        <div className="col-xs-12">
          <div className="row">{formData.map((ele) => ele)}</div>
        </div>
      );
      formData = [];
    }
    if (sectionData) {
      sectionDataDetails.push({
        order: sectionData.order,
        row: sectionData.row,
        element: (
          <div className="col-xs-12 start-sm bottom-sm item">
            <Paper
              key={
                this.state.parentKey +
                '_processSectionData-sectionDataDetails-row-paper' +
                sectionDataDetails.length
              }
            >
              <div className="row bottom-xs">
                <div className="col-xs-12 innerHeader">
                  <PageHeader
                    key={
                      this.state.parentKey +
                      '_processSectionData-sectionDataDetails-row-pageheader' +
                      sectionDataDetails.length +
                      'separator-' +
                      sectionData.label
                    }
                    title={sectionData.label}
                  ></PageHeader>
                  <hr className="hr-custom" />
                  <span style={{ fontWeight: '700', marginLeft: '13px' }}>{sectionData.infoLabel}</span>
                </div>
                {sectionData.fields}
              </div>
            </Paper>
          </div>
        )
      });
      sectionData = undefined;
    }
    return { formData, sectionData };
  }
}

export default FormGenerator;
